"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFieldSafe = exports.initField = void 0;
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
const fields_1 = require("../utils/fields");
const initField = (fieldTypeParam, label, slug = (0, fields_1.generateSlug)(), params = {}) => {
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(fieldTypeParam);
    return {
        slug,
        label,
        field_type: fieldLogic.name,
        icon: fieldLogic.icon,
        params: { ...fieldLogic.params, ...params },
        nested: fieldLogic.params.nested,
    };
};
exports.initField = initField;
const initFieldSafe = (fieldTypeParam, label, slug = (0, fields_1.generateSlug)(), params = {}) => {
    var _a, _b;
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(fieldTypeParam);
    if (!fieldLogic) {
        console.warn(`fieldLogic for ${fieldTypeParam} is not found`);
    }
    return {
        slug,
        label,
        field_type: fieldTypeParam,
        icon: (_a = fieldLogic === null || fieldLogic === void 0 ? void 0 : fieldLogic.icon) !== null && _a !== void 0 ? _a : "",
        params: { ...((_b = fieldLogic === null || fieldLogic === void 0 ? void 0 : fieldLogic.params) !== null && _b !== void 0 ? _b : {}), ...params },
        nested: fieldLogic === null || fieldLogic === void 0 ? void 0 : fieldLogic.params.nested,
    };
};
exports.initFieldSafe = initFieldSafe;
